/**
 * Compare deux valeurs pour déterminer si elles sont égales
 */
export const isEqual = (a: any, b: any, path?: string): boolean => {
  // Égalité stricte
  if (a === b) return true;

  // Les deux sont null/undefined
  if (a == null && b == null) return true;

  // Tableaux
  if (Array.isArray(a) && Array.isArray(b)) {
    // Deux tableaux vides sont égaux
    if (a.length === 0 && b.length === 0) return true;
    // Comparaison en ignorant l'ordre
    return JSON.stringify(a.sort()) === JSON.stringify(b.sort());
  }

  // Cas spécial : tableau vide vs null/undefined (sauf pour les filtres)
  if (!path || !path.includes('filters')) {
    if (Array.isArray(a) && a.length === 0 && (b == null || b === undefined)) return true;
    if (Array.isArray(b) && b.length === 0 && (a == null || a === undefined)) return true;
  }

  // Au moins l'un des deux est null
  if (a == null || b == null) return false;

  return false;
};
